var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "not_activated",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9167",
    "data-name": "Path 9167",
    d: "M17.075,2.995a10,10,0,1,0,0,14.149A10.013,10.013,0,0,0,17.075,2.995Zm-1.1,13.053a8.454,8.454,0,1,1,0-11.957A8.461,8.461,0,0,1,15.98,16.048Z",
    transform: "translate(0 -0.07)",
    fill: "#0091df"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9213",
    "data-name": "Path 9213",
    d: "M235.594,125.909a.832.832,0,0,0-.833.833v5a.833.833,0,1,0,1.666,0v-5A.832.832,0,0,0,235.594,125.909Z",
    transform: "translate(-225.593 -120.95)",
    fill: "#0091df"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9214",
    "data-name": "Path 9214",
    d: "M236.361,341.8a.777.777,0,0,0-.175-.275.794.794,0,0,0-.133-.1.9.9,0,0,0-.3-.125.832.832,0,0,0-.749.225.778.778,0,0,0-.175.275.786.786,0,0,0,0,.633.751.751,0,0,0,.45.45.783.783,0,0,0,.632,0,.974.974,0,0,0,.275-.175.962.962,0,0,0,.175-.275.786.786,0,0,0,0-.633Z",
    transform: "translate(-225.594 -327.91)",
    fill: "#0091df"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pending_icon.ac4275d0d1c655161961e392b7e8aa6f.svg";
export { ForwardRef as ReactComponent };